import type { QuerySanitizer } from './types';
import { productsValidator, regionsValidator } from './sanitize';

export const absValidators: Record<string, QuerySanitizer> = {
  products: productsValidator,
  regions: regionsValidator,
};
